/**
 * What a MyGiving amount field may hold while the member types: digits, at most
 * one decimal point and at most two decimals, trimmed as typed rather than on
 * blur. `1,234.567` → `1234.56`; `-5` → `` (nothing before the minus is a number);
 * `.5` and `1.` are kept so the member can keep going. Commas are removed, since
 * the field puts them back when it reformats on blur.
 */
export function sanitizeAmountInput(value) {
  const cleaned = String(value ?? '').replace(/,/g, '');
  // Never fails: every part can match the empty string, and the match is not
  // anchored, so `-5` matches nothing and comes back blank.
  const [, beforeDecimal, afterDecimal] = cleaned.match(/(\d*)\.?(\d{0,2})/);
  if (cleaned.includes('.') || afterDecimal) return `${beforeDecimal}.${afterDecimal}`;
  return beforeDecimal;
}
